import axios from 'axios';
export const v2CdnUrl = 'https://uat-cdnv2.objek.to/';
export const v2ApiUrl = 'https://apiv2-uat.objek.to';
export const api = axios.create({
    baseURL: v2ApiUrl,
});
